import React, { useCallback, useEffect } from 'react'

import { useLocation, useNavigate, Navigate } from 'react-router-dom'

import { RoutesNames } from '@/routes/routes'
import { BridgeService } from '@/services'
import useGlobalState from '@/contexts/global-state'
import { PageSkeleton } from '@/components/PageSkeletons'
import { Header } from '@/components'
import { WbSessionActions } from '@interco/inter-webview-bridge'

const Main = () => {
  const history = useNavigate()
  const location = useLocation()

  const [{ user }] = useGlobalState()
  const onHeaderBackPress = useCallback(() => {
    if ([RoutesNames.ROOT].includes(location.pathname)) {
      BridgeService.interWbNavigate.requestGoBack()
      return
    }

    history(-1)
  }, [location, history])

  useEffect(() => {
    BridgeService.iWb.addWebviewEventListener(WbSessionActions.GO_BACK, onHeaderBackPress)
  }, [onHeaderBackPress])

  if (user === undefined)
    return (
      <>
        <Header
          title="Portabilidade de Salário"
          onBackClick={() => BridgeService.interWbNavigate.requestGoBack()}
        />
        <PageSkeleton />
      </>
    )
  return <Navigate to={`${RoutesNames.HOME}`} state={{ showVideo: true }} />
}

export default Main
